<template>
    <v-content>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <v-card class="elevation-12">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Вход в систему</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <template v-if="false">
                                Зайти через:
                                <v-btn icon large @click="testAuth">
                                    <v-icon>cloud_upload</v-icon>
                                </v-btn>
                            </template>
                        </v-toolbar>
                        <v-card-text>
                            <template v-if="false">
                                <v-subheader>Войти через соцсети</v-subheader>
                                <v-layout align-center justify-center>
                                    <v-btn round ripple color="warning">Facebook</v-btn>
                                    <v-btn round color="warning">
                                        <v-icon left>cloud_upload</v-icon>
                                        Google
                                    </v-btn>
                                    <v-btn round color="warning">Instagram</v-btn>
                                    <v-btn round color="warning">Github</v-btn>
                                </v-layout>
                                <br/>
                                <v-divider></v-divider>
                            </template>
                            <v-form v-model="loginFormValid">
                                <v-subheader>Войти, используя учетную запись</v-subheader>
                                <v-text-field prepend-icon="person" name="email" v-model="loginData.email"
                                              label="Email" type="email" class="notranslate"
                                              :rules="[rules.required, rules.email]"></v-text-field>
                                <v-text-field id="password" v-model="loginData.password" prepend-icon="lock"
                                              name="password" label="Пароль" class="notranslate"
                                              :rules="[rules.required, rules.minpasswd]"
                                              :append-icon="utility.show1 ? 'visibility' : 'visibility_off'"
                                              @click:append="utility.show1 = !utility.show1"
                                              :type="utility.show1 ? 'text' : 'password'"
                                              required></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat to="/user/register" class="notranslate">Регистрация</v-btn>
                            <v-btn color="primary" :disabled="!loginFormCanSave" @click="authLogin()" class="notranslate">Войти</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    export default {
        data: () => ({
            loginFormValid: false,
            loginData: {
                email: '',
                password: 'Password'
            },
            utility: { snackbarText: '', snackbar: false, show1: false, show2: false, show3: false},
            rules: {
                required: value => !!value || 'Требуется',
                counter: value => value.length <= 20 || 'Max 20 символов',
                minpasswd: value => (value && value.length >= 6) || 'Минимум 6 символов',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            }
        }),
        computed: {
            loginFormCanSave: function () {
                if (this.loginFormValid ) return true;
                return false;
            },
        },
        methods: {
            testAuth: function () {
                this.$http.get('/profile', {data: {}}).then(function (response) {
                    // eslint-disable-next-line
                    console.log(response.data);
                });
            },

            authLogin: function () {
                var this_ = this;
                let user = this_.loginData
                this.$store.dispatch('login', {user}).then(function (response) {
                    this_.response = response
                    // eslint-disable-next-line
                    console.log(this_.response.status);

                    if (this_.response.status === 200) this_.$router.push(this_.$route.query.redirect || '/')
                    else this_.$store.dispatch('processError', this_.response)
                })
            },

            authLogout: function () {
                var this_ = this;
                this.$store.dispatch('logout').then(function () {
                    this_.response = null
                    this_.$router.push('/home')
                })
            }
        },
        created: function () {
            /*
            let this_ = this

            this_.$store.dispatch('checkLogin', {}).then(function (response) {
                if (response.status === 200) this_.$router.push(this_.$route.query.redirect || '/')
                //this_.$router.push('/home')
                else this_.utility.unhide = true
            })
            */
        }
    }
</script>
